import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: '',
        userinfo: {}
    },
    mutations: {
        //登录获取token
        getToken(state, value) {
            console.log(state, value);
            state.token = value
        },
        //退出清空token
        purToken(state, value) {
            state.token = value
        },
        //获取用户信息
        getUserinfo(state, value) {
            state.userinfo = value
        },
        //清空用户信息 
        purUserinfo(state, value) {
            state.userinfo = value
        }
    },
    actions: {},
    modules: {}
})